module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "cn",
    attrs: {
      "id": "_idParaDest-5"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/nav#r_idParaDest-5"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_23",
      "title": "23"
    }
  }, [_vm._v("The Voice of the Beast")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A few days later, I talked about it to Annelise. Then I phoned Mike. No, it wasn’t a joke. And yes, I was a fucking genius. I’d always known it, but thanks anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On April 4, Mike showed up in Siebenhoch. He had a fur hat wedged on his head and a Harry Potter scarf around his neck. Clara shouted, “Uncle Mike! Uncle Mike!” and clapped her hands, as she had done when she was little more than a baby, something of which my partner was very proud.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On April 6, as pumped as quarterbacks at the Super Bowl, we began filming "), _c('i', [_vm._v("Mountain Angels")]), _vm._v(" at Pontives in the Val Gardena, the headquarters of Dolomite Mountain Rescue.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Pontives base was a two-story building surrounded by greenery. Modern, with every comfort, and very clean and tidy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was Moses Ploner, the man who had taken over from Werner as the head of Dolomite Mountain Rescue, who let us make our first reconnaissance tour and introduced us to the rest of the team. People who had saved thousands of lives.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I won’t hide the fact that we were intimidated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We were on tenterhooks until ten in the morning, when the static over the radio gave way to a monotonous voice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Charlie Papa to Dolomite Mountain Rescue.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_24",
      "title": "24"
    }
  }, [_vm._v("Charlie Papa stood for Command Post.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Dolomite Rescue here, go ahead Charlie Papa,” Moses replied, bending toward the microphone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We have a tourist on the east side of the Seceda. Near the Margheri refuge. Over.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Got it, Charlie Papa, over and out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As the first day of shooting had approached, I had constructed a movie in my head involving strong-jawed Navy Seals types zoom-ing from one place to another like balls in a pinball machine, sirens sounding, red lights flashing, and delivering brash lines like, “What are you, a bunch of girls, let’s go kick some ass!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Instead, there was no excitement.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I would soon understand why. The mountains are the last place in which the distinction between sounding authoritative and real authority still counts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That April 6, anyway, I didn’t have time to feel disappointed. Moses Ploner (with a slowness that struck me as truly exasperating) turned to Mike.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you want to come?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Slowly, Mike got up from his chair. Slowly, he hoisted the Sony on his shoulder. He threw me a terrified glance and climbed into the EC135 just as the noise of the turbines went up an octave. I approached the doors of the hangar, just in time to be flung backward by the movement of air from the blades of the helicopter as it took off, and in the blink of an eye the red outline of the EC135 disappeared.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They returned about thirty minutes later. A routine mission for the team from Dolomite Mountain Rescue. The helicopter had reached the scene, the doctor had checked the wound (a sprain), the unfortunate climber had been taken on board and dropped at the hospital in Bolzano, then the EC135 had taken off again and on the way back Mike had received his baptism of air.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We played at being the Luftwaffe, and Mike . . .” Christoph, the "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_25",
      "title": "25"
    }
  }, [_vm._v("doctor, grinned, displaying a small bag full of vomit, while my partner, as white as a sheet, ran to the bathroom.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Welcome to the Dolomite Mountain Rescue.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In my memory, the next few months are like a movie on fast-forward.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The helicopter taking off in almost zero visibility and the exchange of quips between Mike and Ismaele, the pilot of the EC135 (Ismaele was the brother of Moses: Ma and Pa Ploner must have been big fans of the Bible): “Didn’t you say we need two hundred meters’ visibility to fly?” “But this "), _c('i', [_vm._v("is")]), _vm._v(" two hundred meters’ visibility. Even three hundred if I shut my eyes, I think.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The faces of the injured, above all, blur into one. The terror in the eyes of a young man frozen by a panic attack. The pain of a shepherd with a leg broken by a landslide of rocks. The half-frozen tourist. The couple lost in the fog. An infinity of broken bones, dislocated pelvises, shattered joints, blood, sweat. Many tears, few thanks. Mike sleeping four hours a night, swept along by adrenaline. Radio calls that turned your stomach. Mike stung by thirteen different varieties of mosquito. My initiation: being mummified in a vacuum bag and left there to understand the intoxication of claustrophobia. Mike shaking his head to tell me no, better not do interviews, there’s no time. The request for “emergency spiritual aid” tormenting you day and night.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And of course, the Rules.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The men of Dolomite Mountain Rescue had one prophet (Moses Ploner), a chariot of fire to ascend to the Kingdom of Heaven (the EC135), and at least two hundred thousand rules recorded only in memory. It was hard to keep up with them. Rules sprouted like mushrooms.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Mealtime Rule may have been the strangest (and in some ways the most disturbing). Never mind if it is seven in the morning or four "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_26",
      "title": "26"
    }
  }, [_vm._v("in the afternoon, at the exact moment when you sit down to eat, the alarm will sound and the team will have to leave for a mission. The first time, I told myself it was just a coincidence. The second time, I thought fate was playing a trick. By the tenth time, I had started to blame God and universal entropy. A few months into shooting, I just ignored it.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That was the way it was, period, so why worry about it?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For me, who as the writer didn’t participate in the direct action (in Mike McMellan’s immortal words: “You just have to figure out how the fuck to tell the story, the Sony will take care of the rest”), the Mealtime Rule had unexpected benefits. The alarm would sound, the team would go down into the hangar, the helicopter would take off, and I’d finish the others’ ice cream or dessert, sitting in the wireless operator’s seat. The pen fattens quicker than the camera.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Until lunchtime on September 15.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Mike had been showing signs of fatigue for a few days now. He was pale and drawn.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The first operation of the day had gone smoothly. The weather was good, and the Milanese tourist involved had simply been scared and had the idea that the team’s helicopter was a kind of taxi that could take him down to the valley. The second operation had been a photocopy of the first, but instead of the Corno Bianco they’d had to fly all the way to the Sasso Lungo.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When Mike came back, I noticed that he was dragging his feet. He changed the camera battery ("), _c('i', [_vm._v("our")]), _vm._v(" First Rule) and then collapsed onto a chair. Within a few minutes he was asleep, the Sony clutched to his chest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Around one o’clock, since everyone’s stomach was rumbling, Moses decided that the time had come to defy the Mealtime Rule. Stew. Potatoes. Strudel. We never got to eat the strudel. A pity, because it looked really appetizing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_27",
      "title": "27"
    }
  }, [_vm._v("The alarm sounded just when we’d started filling our plates. Mike stood up, grabbed the camera, and fell back on the chair, gasping.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Christoph soon sounded his orders: “Tachipirina, warm blankets, grandmother’s broth, and a good night’s sleep.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mike shook his head and stood up again. “I’m fine, no problem.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He didn’t even have time to lift the camera before Moses took him by the arm and stopped him. “You’re not coming. Send "), _c('i', [_vm._v("him")]), _vm._v(" if you like. You’re not getting in the helicopter in that condition.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Him")]), _vm._v(", of course, meant "), _c('i', [_vm._v("me")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Having said this, he turned and went down the stairs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mike and I looked at each other for a moment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I tried to sound confident. “Give me the Sony, partner, I’ll win you an Oscar.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oscars are for movies,” Mike grunted. “We’re making television, Salinger.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Reluctantly, he passed me the camera. It was heavy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Make sure to press "), _c('i', [_vm._v("record")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Amen.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Christoph’s voice from the stairs: “Are you coming?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I went.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I had never been in the EC135. The seat reserved for Mike was tiny. The EC isn’t one of those transport giants you see in movies, it’s a small helicopter, agile and powerful. The best possible means of rescue in the peaks of the Dolomites, but damned uncomfortable if you have to do any filming.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As we left the ground, my stomach rose into my mouth. Not only because of the acceleration. Call it simple fear. Looking out of the window didn’t help. I saw the Pontives base disappear and swallowed a couple of times in order not to throw up. Manny, the team member sitting next to me, squeezed my hand. His hand was as big as my forearm. A mountain man’s gesture that meant: take it easy. Believe me, it worked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No more fear: just the sky. Clear.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("God, how beautiful it was.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_28",
      "title": "28"
    }
  }, [_vm._v("Christoph gave me a wink and signaled to me to put on my headphones. “How’s it going, Salinger?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Terrific.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I was about to add something else, but Moses’s voice interrupted me. “Dolomite Mountain Rescue to Charlie Papa. Do you have any information for us?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I started to film seriously, hoping that my lack of experience wouldn’t give Mike hives when he saw the footage.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He could be a real pain in the butt when he wanted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Charlie Papa here.” The distorted voice of the 118 switchboard came over the radio. “German female, tourist, on the Ortles. Ended up in a crevasse at 3,200 meters. On the Schückrinne.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Received, Charlie Papa. We’ll be there in . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“. . . seven minutes,” Ismaele said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“. . . seven minutes. Over and out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Moses put down the radio and turned to me. I lifted the camera and gave him a beautiful close-up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Have you ever seen the Ortles?” he asked me straight out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Only in photographs.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Moses nodded to himself. “It’ll be a beautiful operation, you’ll see.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then he turned, erasing me from his world.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s the Schückrinne?” I asked Christoph.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There are various ways to reach the summit of the Ortles,” the doctor replied, grim faced. “The simplest is the Normal North, you need to be trained and it’s no joke, but you don’t go up onto a glacier unprepared, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We once pulled up a guy wearing flip-flops around there,” Ismaele cut in cheerfully.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Flip-flops?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“At 3,000 meters,” he said with a sneer. “People are strange, aren’t they?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I couldn’t help but agree.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Christoph continued with his explanation. “The Schückrinne is the "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_29",
      "title": "29"
    }
  }, [_vm._v("worst way. The rock is crumbly, some of the slopes are fifty-five degrees, and the ice . . . you never know when it’ll do something strange. It’s a bad place even for the most expert mountaineers. Charlie Papa says the tourist has ended up in a crevasse, and that’s really bad.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Because she might have broken her leg. Or both legs. And maybe also her pelvis. She might have hit her head. Plus the bottom of the crevasse in a glacier is terrible, there’s water. You feel . . .” Christoph looked for the right image. “You feel as if you’re inside a glass of "), _c('i', [_vm._v("granita")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s going to be fun,” Ismaele said, giving the camera one of his unmistakable smiles, halfway between an abandoned cub and a mischievous little boy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another rule of the rescue team. Nothing is difficult. Ever. Because, as Moses Ploner said: “Difficult is only what you can’t do.” In other words: if it’s difficult, stay at home.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The German woman would have done well to follow Moses’s rule, I thought. It didn’t occur to me that "), _c('i', [_vm._v("I")]), _vm._v(" should have followed it, too.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Seven minutes later, the EC135 was circling over the white slope of the Ortles. I had never seen a glacier before, and it was magnificent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I would soon change my mind.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Moses flung open the door and an icy current swept over me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There she is.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I tried to film the spot he was pointing at.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You see that crevasse? The woman is there.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I couldn’t figure out how Moses could possibly be so sure it was the right crevasse. In that direction, there were at least three or four of them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The EC135 was vibrating like a blender. It descended a few hundred meters, until the Sony framed the clue that Moses’s eyes had caught before mine. A series of prints in the snow that suddenly broke off.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The EC135 paused.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No way we can land there, boys,” Ismaele said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I stared openmouthed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ismaele wasn’t a pilot. He was the patron saint of all helicopter "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_30",
      "title": "30"
    }
  }, [_vm._v("pilots. In Mike’s footage I had seen him land (“park” was the word he himself used) on peaks not much bigger than an apple, surf on currents of air that would have brought the Red Baron down, and take the EC135 so close to a rock wall, it seemed as if the blades would shatter at any moment. Without ever losing that impish grin. But now this same Ismaele was worried.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Uh-oh.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Manny? Go down with the pulley. Get her and bring her straight up. I’m not unloading anyone. It’s too damned hot. And this wind . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I didn’t understand. We were on a glacier, weren’t we? A glacier’s cold, or am I wrong? So what the hell did “It’s too damned hot” mean? And what did the wind have to do with it?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now wasn’t the time to ask questions. Manny was already securing himself to the pulley.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I looked at him and suddenly my heart started to pump gunpowder. So, as the EC135 hovered between two slabs of rock above the fissure in the glacier, words emerged from my mouth, words that would change the course of my life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Can I go down with you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Manny, already standing on the helicopter’s runner, made a sign to Moses, the pulley taut in his leather-gloved right hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Can I go down with Manny? I’ll film the whole thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can’t pull three people up. Too much wind,” Ismaele said. “And besides, the temperature’s . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fuck the temperature.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fuck everything. I wanted to "), _c('i', [_vm._v("go down")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can stay down there. Manny’ll take the woman up and then come back for me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Easy, right?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Moses hesitated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_31",
      "title": "31"
    }
  }, [_vm._v("Manny smiled. “I think we can do it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Moses looked hard at me. “OK,” he said reluctantly. “But hurry up about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I got up from my seat (it wasn’t Mike’s anymore, it was "), _c('i', [_vm._v("my")]), _vm._v(" seat), Christoph passed me a harness, I put it on and tied myself to Manny. We leaned out of the door, our feet planted on the runner of the EC135. Christoph gave me the thumbs-up. Manny tapped on my helmet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Three, two, one.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The void swallowed us.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I was scared. I wasn’t scared. I was terrified. I "), _c('i', [_vm._v("wasn’t")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I’d never felt more alive.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ten meters,” I heard Manny say clearly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I looked down.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was too dark in the crevasse to see anything. I aimed the camera and continued filming.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“One meter.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Manny propped himself on the ridge of the crevasse.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Stop.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The pulley stopped its descent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Manny lit the lamp on his helmet. The beam of light plumbed the darkness. We immediately spotted the woman. She was wearing a fluorescent orange jacket. She was leaning against the wall of ice. She raised her hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s thirty meters,” Manny said. “Down, slowly.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The pulley started humming again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I saw the iridescent surface of the Ortles disappear and I went blind, while Manny controlled the descent. I opened and closed my eyes several times to accustom myself to the darkness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Five meters,” Manny said. “Three.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was a strange luminosity down there. The sunlight was refracted in a thousand flashes that blurred your vision, creating rainbow-colored halos and scintillas.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_32",
      "title": "32"
    }
  }, [_vm._v("The bottom of the crevasse, two and a half meters wide, was covered in water. In the water, as Christoph had said, pieces of ice of various sizes floated. It was just like ending up inside a "), _c('i', [_vm._v("granita")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Stop.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Manny unhooked his harness, then mine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I was immersed in the icy water up to my knees.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you alone, signora?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The woman seemed not to understand the question.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Leg,” she stammered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s in shock,” Manny said. “Move as far away as you can. Let’s see if we can do this.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I flattened my back against the wall of ice. My breath condensed in little clouds. I hoped they weren’t going to end up in the frame.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The woman looked first at Manny then at her own leg. “It hurts.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You see the helicopter? There’s a doctor on it who’ll give you a good dose of painkillers.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The woman groaned and shook her head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Manny secured himself to the rope of the pulley, then, pulling on the cable, tied it to the woman’s harness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Pulley, Moses.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The pulley lifted the two of them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The woman screamed with all the breath she had in her. I held back the urge to raise my hands to my ears. If I had, I would have dropped the camera, and then Mike really would have killed me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Slowly and painfully.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The ascent was textbook. The cable was like a straight line drawn in India ink.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I saw Manny and the woman go up and up and finally leave the crevasse.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I was alone.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_33",
      "title": "33"
    }
  }, [_vm._v("What does the footage on the Sony show at this point?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The walls of the crevasse. Vague glimmers in the total darkness. The beam of light from the camera moving from one side to the other, sometimes in slow motion, sometimes hysterically. Iridescent little cubes floating in the pool of water around my legs. The reflection of my face against the ice. First smiling, then attentive, with the expression of someone trying to eavesdrop on a private conversation. Finally contorted, eyes like a trapped animal, cold-darkened lips pulled over my teeth in a sneer that didn’t belong to me. A medieval death mask.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And over everything: the voice of the Ortles. The cracking of the ice. The hissing of the mass of the Ortles as it continued to move as if from two hundred thousand years ago to the present.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The voice of the Beast.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Manny descending, worried. My name repeated several times.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("God’s scream swallowing Manny.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The passing of seconds that stops making sense. The terrifying awareness that the time of the glacier isn’t human time. It’s an alien, hostile time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And the darkness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I sank into the gloom that devours worlds. I found myself drifting in deep space. A single, vast, endless, eternal night of spectral whiteness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eight letters: “Darkness.” Three letters: “Ice.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At last, salvation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Too hot, Moses had said. Too hot meant avalanche. God’s scream. And the avalanche had taken Manny. And along with Manny, through the pulley cable, the Beast had snatched the EC135 and dragged it to the ground, crushing it as you would a troublesome insect. Why hadn’t Moses cut the cable? If he had, Manny would have been crushed but the avalanche wouldn’t have touched the helicopter. The Carabinieri wondered that, and the reporters wondered that. Not the rescuers who pulled me to safety. They "), _c('i', [_vm._v("knew")]), _vm._v(". It’s all in the Rules.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The pulley cable can’t be cut because in the mountains you never "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_34",
      "title": "34"
    }
  }, [_vm._v("leave anyone behind. For any reason. That’s the way it is, and that’s the way it has to be.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nothing remained of Moses, Ismaele, Manny, Christoph or the German woman. The fury of the avalanche, which had been unleashed by the heat and the wind, had swept them away, leaving their bodies unrecognizable. The EC135 was a carcass farther down the mountain.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But the accident on the Ortles didn’t signal the end of Dolomite Mountain Rescue, just as it wasn’t the end of my story.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As I said, nine letters.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Beginning.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0af06fb2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062680181_Chapter_3.vue
// module id = 80
// module chunks = 0